import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyA5Jgt-s6PpauGjj3n6rJD4Pl5ovFF3FUE",
  authDomain: "slack-clone-b7a72.firebaseapp.com",
  projectId: "slack-clone-b7a72",
  storageBucket: "slack-clone-b7a72.appspot.com",
  messagingSenderId: "643074349933",
  appId: "1:643074349933:web:9045166f838231b6d79864",
  measurementId: "G-97E8V1LXBQ"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db =  firebaseApp.firestore();
const auth = firebase.auth();
const provider =  new firebase.auth.GoogleAuthProvider();

export { auth, db, provider }